<template>
  <va-show-layout :actions="['list', 'edit', 'delete']">
    <va-show :item="item">
      <v-row justify="center">
        <v-col lg="8" md="12">
          <base-material-card>
            <template v-slot:heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <va-field
                source="livestock_type_entity.class"
                type="select"
                reference="livestock_types"
                chip></va-field>
              <va-field source="livestock_num" type="number"></va-field>
              <va-field
                source="livestock_operation_entity.livestock_operation"
                type="select"
                reference="livestock_operations"
                chip></va-field>
              <va-field source="barn_time" type="number"></va-field>
              <va-field
                source="barn_type_entity.barn_type"
                type="select"
                reference="barn_types"
                chip></va-field>
              <va-field
                source="manure_storage.man_stor_loc"
                type="select"
                reference="manure_storages"
                chip></va-field>
              <va-field source="livestock_units" type="number"></va-field>
              <va-field source="manure_production" type="number"></va-field>
              <va-field source="comment"></va-field>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
